import formBaseMixin from '../../../components/form/form-base-mixin.js'

export default {
  mixins: [formBaseMixin],
  title: function () {
    return this.title
  },
  data () {
    return {
      fields: {
        name: '',
        start_year: '',
        end_year: '',
        measure_id: '',
        order: null
      }
    }
  },
  computed: {
    title () {
      if (this.$route.params.id) {
        return 'Редактирование целевого показателя'
      }
      return 'Добавление нового целевого показателя'
    },
    item () {
      return this.$store.getters.readUrlEndpoint(this.getItemEndpoint(this.$route))
    },
    measureTypes () {
      return this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()).measure
    }
  },
  methods: {
    closeForm () {
      this.$refs.modalForm.redirectToPrev()
    },
    additionalValidate: async function (hasError = false, errors = {}) {
      if (this.fields.start_year || this.fields.end_year) {
        if (!this.fields.start_year) {
          errors.start_year = 'Укажите начальный год'
          hasError = true
        }
        if (!this.fields.end_year) {
          errors.end_year = 'Укажите конечный год'
          hasError = true
        }
        if (hasError === false && this.fields.end_year < this.fields.start_year) {
          hasError = true
          errors.end_year = 'Конечный год должен быть больше начального'
        }
      }
      console.log(errors)
      if (hasError === true) {
        this.formValidator.handleServerErrors({data: {errors}}, this)
        return Promise.reject(1)
      }
      return Promise.resolve(1)
    },
    prepareFieldsForSend (fields = {}) {
      if (fields.order === null || fields.order === undefined) {
        fields.order = 1
      } else {
        fields.order = +fields.order
      }
      return fields
    },
    update () {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        this.fields.measure_id = this.fields.measure.id
        this.fields.start_year = this.fields.start_year.toString()
        this.fields.end_year = this.fields.end_year.toString()
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getCollectionEndpoint(),
      fromCache: true
    }))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}

